module.exports = {
    isValidEmail: (email) => {
        return /\S+@\S+\.\S+/.test(email)
    },

    isValidUrl: (string) => {
        var result = string.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
        return (result !== null)
    },

    isValidDate: (string) => {
        const regex = /^20\d{2}-(0[1-9]|1[0-2])-(0[1-9]|1\d|2\d|3[01])$/
        return regex.test(string)
    },

    isValidTime: (string) => {
        const regex = /^(0\d|1\d|2[0-4]):([0-5]\d)$/
        return regex.test(string)
    },

    isValidMaxCharacters: (string, maxLength) => {
        return string.length <= maxLength
    },

    isLimitCharacters: (string, maxLength) => {
        return string.length > maxLength
    },

    isValidPhoneNumber: (string) => {
        const regex = /^\d{10}$/
        return regex.test(string)
    },

    trimDateTime: (date) => {
        const months = {
            'Jan': '01',
            'Feb': '02',
            'Mar': '03',
            'Apr': '04',
            'May': '05',
            'Jun': '06',
            'Jul': '07',
            'Aug': '08',
            'Sep': '09',
            'Oct': '10',
            'Nov': '11',
            'Dec': '12'
        }
        if (!date) return null

        const splitDate = date.toString().split(' ');
        return `${splitDate[3]}-${months[splitDate[1]]}-${splitDate[2]}`;
    },

    formPageList: (pageName) => {
        // const formList = ['mulesoftmentors', 'research-sign-up', '/community/conferences/new', 'tftlicenses', 'agentforce-research-sign-up'];
        const formList = [];
        return formList.includes(pageName);
    },

    mulesoftFormDates: () => {
        const utcDate = new Date();
        const formattedPST = utcDate.toLocaleString("en-US", {
            timeZone: "America/Los_Angeles", // Set the time zone to PST
            hour12: false,
            year: "numeric"
        });
        const janMonth = `01${formattedPST}`;
        const febMonth = `02${formattedPST}`;
        const marchMonth = `03${formattedPST}`;
        const aprilMonth = `04${formattedPST}`;
        const mayMonth = `05${formattedPST}`;
        const juneMonth = `06${formattedPST}`;
        const julyMonth = `07${formattedPST}`;
        const augustMonth = `08${formattedPST}`;
        const septMonth = `09${formattedPST}`;
        const octMonth = `10${formattedPST}`;
        const novMonth = `11${formattedPST}`;
        const decMonth = `12${formattedPST}`;

        return {
            [janMonth]: {
                startDateInfo: '1st Jan',
                endDateInfo: '31st Jan',
                formOpenDate: 'March 1st',
                formEndDate: 'March 31st',
                isOpened: false
            },
            [febMonth]: {
                startDateInfo: 'Feb 1st',
                endDateInfo: 'Feb 28th',
                formOpenDate: 'March 1st',
                formEndDate: 'March 31st',
                isOpened: false
            },
            [marchMonth]: {
                startDateInfo: 'March 1st',
                endDateInfo: 'March 31st',
                // formOpenDate: 'April 1st',
                // formEndDate: 'April 30th',
                isOpened: true
            },
            [aprilMonth]: {
                startDateInfo: '1st April',
                endDateInfo: '30th April',
                formOpenDate: 'June 1st',
                formEndDate: 'June 30th',
                isOpened: false
            },
            [mayMonth]: {
                startDateInfo: 'May 1st',
                endDateInfo: 'May 31st',
                formOpenDate: 'June 1st',
                formEndDate: 'June 30th',
                isOpened: false
            },
            [juneMonth]: {
                startDateInfo: 'June 1st',
                endDateInfo: 'June 30th',
                isOpened: true
            },
            [julyMonth]: {
                startDateInfo: '1st July',
                endDateInfo: '31st July',
                formOpenDate: 'Dec 1st',
                formEndDate: 'Dec 31st',
                isOpened: false
            },
            [augustMonth]: {
                startDateInfo: 'Aug 1st',
                endDateInfo: 'Aug 31st',
                formOpenDate: 'Dec 1st',
                formEndDate: 'Dec 31st',
                isOpened: false
            },
            [septMonth]: {
                startDateInfo: 'Sept 1st',
                endDateInfo: 'Sept 30th',
                formOpenDate: 'Dec 1st',
                formEndDate: 'Dec 31st',
                isOpened: true
            },
            [octMonth]: {
                startDateInfo: 'Oct 1st',
                endDateInfo: 'Oct 31st',
                formOpenDate: 'March 1st',
                formEndDate: 'March 31st',
                isOpened: false
            },
            [novMonth]: {
                startDateInfo: 'Nov 1st',
                endDateInfo: 'Nov 30th',
                formOpenDate: 'March 1st',
                formEndDate: 'March 31st',
                isOpened: false
            },
            [decMonth]: {
                startDateInfo: 'Dec 1st',
                endDateInfo: 'Dec 31st',
                formOpenDate: 'March 1st',
                formEndDate: 'March 31st',
                isOpened: false
            }
        }
    }
}
